// src/components/apps/a5200/A5200MappingsTab.js
import * as React from 'react';
import Box from '@mui/material/Box';

import EditorTabPanel from '../../common/editor/EditorTabPanel';
import EditorSelect from '../../common/editor/EditorSelect';

// 🔹 i18n
import { useI18n } from '../../../i18n/I18nContext';

function MappingField(props) {
  const {
    label,
    buttonName,
    object,
    setObject
  } = props;

  const { t } = useI18n();

  const NONE = "none";

  let value = NONE;
  if (object.props.mappings) {
    value = object.props.mappings[buttonName];
    if (!value) {
      value = NONE;
    }
  }

  const setValue = (str) => {
    let mappings = object.props.mappings;
    if (!mappings) {
      mappings = {};
    }

    if (str === NONE) {
      delete mappings[buttonName];
    } else {
      mappings[buttonName] = str;
    }

    const props = { ...object.props, mappings: mappings };
    setObject({ ...object, props });
  };

  const menuItems = [];
  // Antes: "(none)"
  menuItems.push({ value: NONE, name: t("a5200MappingsNone") });

  const getName = (key, def) => {
    let name = null;
    if (object.props.descriptions) {
      name = object.props.descriptions[key];
    }
    if (!name) {
      name = def;
    }
    return name;
  };

  // Keypad buttons
  menuItems.push({ value: "start", name: getName("start", t("a5200Start")) });
  menuItems.push({ value: "pause", name: getName("pause", t("a5200Pause")) });
  menuItems.push({ value: "reset", name: getName("reset", t("a5200Reset")) });

  const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"];
  for (let i = 0; i < KEYS.length; i++) {
    const key = KEYS[i];
    menuItems.push({
      value: key,
      name: getName(key, `${t("a5200KeypadPrefix")} ${key}`)
    });
  }

  menuItems.push({
    value: "topfire",
    name: getName("topfire", t("a5200TopFire"))
  });
  menuItems.push({
    value: "bottomfire",
    name: getName("bottomfire", t("a5200BottomFire"))
  });

  // Ensure value is in values
  let found = false;
  for (let i = 0; i < menuItems.length; i++) {
    const item = menuItems[i];
    if (item.value === value) {
      found = true;
      break;
    }
  }

  if (!found) {
    value = NONE;
  }

  return (
    <div>
      <EditorSelect
        label={label}
        value={value}
        menuItems={menuItems}
        onChange={(e) => { setValue(e.target.value); }}
      />
    </div>
  );
}

export default function A5200MappingsTab(props) {
  const {
    tabValue,
    tabIndex,
    setObject,
    object
  } = props;

  const { t } = useI18n();

  return (
    <EditorTabPanel value={tabValue} index={tabIndex}>
      <Box sx={{ m: 1.5 }}>
        {/* Antes: "Create game-specific mappings from the Atari 5200 keys and buttons to the gamepad." */}
        {t("a5200MappingsDescription")}
      </Box>
      <MappingField
        label={t("a5200ButtonALabel")}
        buttonName="a"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t("a5200ButtonBLabel")}
        buttonName="b"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t("a5200ButtonXLabel")}
        buttonName="x"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t("a5200ButtonYLabel")}
        buttonName="y"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t("a5200LeftBumperLabel")}
        buttonName="lb"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t("a5200RightBumperLabel")}
        buttonName="rb"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t("a5200LeftTriggerLabel")}
        buttonName="lt"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t("a5200RightTriggerLabel")}
        buttonName="rt"
        object={object}
        setObject={setObject}
      />
    </EditorTabPanel>
  );
}